import { validateAccount as validateAccountOrThrow } from '../core/support/validation/account';
import { validateUser as validateUserOrThrow } from '../core/support/validation/user';

type ValidationResult =
  | { isValid: true; reason?: undefined }
  | { isValid: false; reason: string };

// Convert to "safe" validators meaning instead of throwing will return ValidationResult
export const validateAccount = toSafeValidate(validateAccountOrThrow);
export const validateUser = toSafeValidate(validateUserOrThrow);

function toSafeValidate<Args extends Array<unknown>>(
  validate: (...args: Args) => void,
) {
  return (...args: Args): ValidationResult => {
    try {
      validate(...args);
      return { isValid: true };
    } catch (error) {
      // TODO: i18n
      const message = error instanceof Error ? error.message : String(error);
      return { isValid: false, reason: message };
    }
  };
}
